/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mass`)
};

const es_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa`)
};

const de_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse`)
};

const nl_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const fr_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse`)
};

const it_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const pt_br2_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const pt_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa`)
};

const ja_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質量`)
};

const zh_massmol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_field_mass = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_field_mass(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_field_mass", locale)
	if (locale === "en") return en_massmol_field_mass(inputs)
	if (locale === "es") return es_massmol_field_mass(inputs)
	if (locale === "de") return de_massmol_field_mass(inputs)
	if (locale === "nl") return nl_massmol_field_mass(inputs)
	if (locale === "fr") return fr_massmol_field_mass(inputs)
	if (locale === "it") return it_massmol_field_mass(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_field_mass(inputs)
	if (locale === "pt") return pt_massmol_field_mass(inputs)
	if (locale === "ja") return ja_massmol_field_mass(inputs)
	return zh_massmol_field_mass(inputs)
};